export const fadeUp = 'wow animate__animated animate__fadeInUp';
